import { Box, IconButton, Popper, type Theme } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ICON_COLOR_MAP: Record<'gray' | 'red' | 'green', string> = {
  gray: '#8A9097',
  red: '#FF0000',
  green: '#49AA75',
};

export const ViewerContainer = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const OriginalViewerWrapper = styled(Box)(() => ({
  flex: 1,
  minWidth: 0,
}));

export const CrossRefIconButton = styled(IconButton, {
  shouldForwardProp: prop => prop !== 'iconColor',
})<{ iconColor: string }>(({ theme, iconColor }: { theme: Theme; iconColor: string }) => ({
  marginLeft: theme.spacing(0.5),
  padding: theme.spacing(0.25),
  color: iconColor,
}));

export const CrossRefPopper = styled(Popper)(({ theme }: { theme: Theme }) => ({
  zIndex: theme.zIndex.modal,
}));
